import React, { Component } from 'react';
import DataTableRow from "./DataTableRow";

export default class DataTableBody extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <tbody style={{
                fontFamily: this.props.option.fontFamilyBody,
                fontSize: this.props.option.fontSizeBody,
                fontWeight: this.props.option.isBoldBody ? 'bold' : 'normal',
                color: this.props.option.fontColorBody,
            }}>
                {
                    this.props.rows.map((c, i) => (
                        <DataTableRow key={i} index={i} row={c} rows={this.props.rows} columns={this.props.columns} option={this.props.option} />
                    ))
                }
            </tbody>
        );
    }
}
